import styled from 'styled-components'

import theme from '../../theme'

const defaultStyles = `
  & .ant-input-number-wrapper .ant-input-number-group-addon,
  & .ant-input-number-wrapper .ant-input-number {
    background-color: ${theme.colors.white}
  }
`

const hasValueNotInFocusStyles = `
  & .ant-input-number:not(:focus) .ant-input-number-group-addon,
  & .ant-input-number:not(:focus-within) .ant-input-number-group-addon,
  & .ant-input-number-wrapper:not(:focus) .ant-input-number-group-addon,
  & .ant-input-number-wrapper:not(:focus-within) .ant-input-number-group-addon,
  & .ant-input-number:not(.ant-input-number-focused){
    border: 1px solid ${theme.colors.blue3};
    background-color: ${theme.colors.blue1};
    color: ${theme.colors.blue7};
    box-shadow: none;
  }
  & .ant-input-number.ant-input-number-focused {
    border: 1px solid ${theme.colors.blue3};
    color: ${theme.colors.blue7};
    box-shadow: none;
  }
`
const notFocusWithErrorStyles = `
  & .ant-input-number:not(:focus) .ant-input-number-group-addon,
  & .ant-input-number:not(:focus-within) .ant-input-number-group-addon,
  & .ant-input-number-wrapper:not(:focus) .ant-input-number-group-addon,
  & .ant-input-number-wrapper:not(:focus-within) .ant-input-number-group-addon,
  & .ant-input-number:not(.ant-input-number-focused) {
    border: 1px solid ${theme.colors.red3};
    background-color: ${theme.colors.red1};
    color: ${theme.colors.red7};
    box-shadow: none;
  }
  & .ant-input-number.ant-input-number-focused {
    border: 1px solid ${theme.colors.red3};
    background-color: ${theme.colors.white};
    color: ${theme.colors.red7};
    box-shadow: none;
  }
`
const NumberInputContainer = styled.span<{ error?: boolean; value?: number }>`
  width: 100%;
  display: flex;
  flex-direction: column;
  transition: 0.3 background-color, 0.3 color, 0.3 border, 0.3 box-shadow;

  & .ant-input-number-wrapper {
    height: 56px;
  }

  & .ant-input-number:not(:hover) {
    border: 1px solid transparent;
  }

  // on focus and hover, only addons
  & .ant-input-number:hover .ant-input-number-group-addon,
  & .ant-input-number:focus .ant-input-number-group-addon,
  & .ant-input-number:focus-within .ant-input-number-group-addon,
  & .ant-input-number-wrapper:focus .ant-input-number-group-addon,
  & .ant-input-number-wrapper:hover .ant-input-number-group-addon,
  & .ant-input-number-wrapper:focus-within .ant-input-number-group-addon {
    border: 1px solid ${(props) => (props.error ? theme.colors.red3 : theme.colors.blue3)};
    background-color: ${theme.colors.blue1};
    color: ${theme.colors.blue7};
    box-shadow: none;
  }

  // on focus and hover, only input field
  & .ant-input-number-wrapper:focus .ant-input-number,
  & .ant-input-number-wrapper:hover .ant-input-number,
  & .ant-input-number-wrapper:focus-within .ant-input-number {
    border: 1px solid ${(props) => (props.error ? theme.colors.red3 : theme.colors.blue3)};
    background-color: ${theme.colors.white};
    box-shadow: none;
  }

  // no value, not in focus, no error
  ${(props) => props.value == undefined && !props.error && defaultStyles}

  // has value, not in focus, no error
  ${(props) => props.value != undefined && props.value && !props.error && hasValueNotInFocusStyles}
  
  // has value, not in focus, error
  ${(props) => props.value != undefined && props.value && props.error && notFocusWithErrorStyles}

  & .ant-input-number-group-wrapper {
    width: 100%;
    border-radius: 4px;
    background-color: #ffffff;
    box-shadow: 0px 1px 2px rgb(0 0 0 / 5%);
    border-color: transparent;
  }
  & .error-placeholder {
    height: 20px;
    margin-top: 4px;
  }
  & .error {
    color: ${theme.colors.red7};
    min-height: 16px;
    font-size: ${theme.fontSizes.small};
    line-height: 20px;
    font-weight: ${theme.fontWeights.semiBold};
  }

  & .ant-input-number.ant-input-number-focused {
    box-shadow: none;
  }

  & .ant-input-number-input {
    color: ${(props) => (props.error ? theme.colors.red7 : theme.colors.blue7)};
    font-weight: ${theme.fontWeights.semiBold};
    // if !value, then showing placeholder
    font-size: ${(props) => (props.value ? '12px' : '14px')};
    line-height: 16px;
    border-radius: 0;
    border-left: 1px solid ${theme.colors.gray4};
    border-right: 1px solid ${theme.colors.gray4};
    transition: none;
  }

  & .ant-input-number-group-addon {
    min-width: 40px;
    border-color: transparent;
    border-radius: 4px;
    & > div {
      position: absolute;
      top: 0;
      left: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      width: 100%;
      font-size: 16px;
    }
  }

  & .ant-input-number-input-wrap,
  & .ant-input-number-input {
    height: 100%;
  }

  & .ant-input-number-group-addon:hover {
    cursor: pointer;
    color: ${theme.colors.blue7}
    border: 1px solid ${(props) => (props.error ? theme.colors.red3 : theme.colors.blue3)};
  }

  & .ant-input-number-focused,
  & .ant-input-number-focused > .ant-input-number-group-addon,
  & .ant-input-number-focused .ant-input-number-group-addon {
    background-color: ${theme.colors.blue1};
    border: 1px solid ${(props) => (props.error ? theme.colors.red3 : theme.colors.blue3)};
    color: ${theme.colors.blue7};
    box-shadow: none;
  }
`

export { NumberInputContainer }
